import { Typography, Button } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { ProjectTemplateVersion } from '@/types/project-templates'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type DeleteProjectTemplateVersionDialogProps = {
  overlay: OverlayState
  version: ProjectTemplateVersion | null
  onDelete: () => void
  onCancel: () => void
}

export default function DeleteProjectTemplateVersionDialog({
  overlay,
  version,
  onDelete,
  onCancel,
}: DeleteProjectTemplateVersionDialogProps) {
  if (!version) return null

  return (
    <Dialog {...overlay} title="Delete Template Version" maxWidth="xs">
      <DialogContent>
        <Typography>
          You are about to delete template version{' '}
          <strong>v{version.version.join('.')}</strong>. This action cannot be
          undone.
        </Typography>

        <Typography sx={{ mt: 2 }}>
          Are you sure you want to proceed?
        </Typography>
      </DialogContent>

      <DialogFooter>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onDelete}>
          Delete
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
